export default "__VITE_ASSET__34827191__"